import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Image from "next/image";
import Lightbox from "yet-another-react-lightbox";
import { getImageUrl, NextImgCustomLoader } from "utils/helperFunction";

export default function GalleryLightBox({ images, setIndex, index }) {
  const photos = images.map(({ id, attributes }) => {
    const { formats, caption } = attributes;
    if (attributes.mime.includes("video")) {
      return {
        type: "video",
        width: 1280,
        height: 720,
        poster: "/images/video-poster.png",
        sources: [
          {
            src: process.env.BASE_URL + attributes.url,
            type: "video/mp4",
          },
        ],
      };
    } else {
      const image = getImageUrl(formats || [], ["large", "medium"]);
      const width = image.width * 4;
      const height = image.height * 4;
      return {
        src: process.env.BASE_URL + image.url,
        key: id,
        width,
        height,
        alt: caption,
      };
    }
  });

  return (
    <Lightbox
      open={index >= 0}
      index={index}
      close={() => setIndex(-1)}
      plugins={[Fullscreen, Video, Zoom]}
      /*thumbnails={{
        width: 120,
        height: 90,
        border: 0,
        borderRadius: 8,
        gap: 15,
        imageFit: "contain",
        padding: 0,
        vignette: false,
      }}*/
      slides={photos}
      render={{
        slide: (image, offset, rect) => {
          const width = Math.round(
            Math.min(rect.width, (rect.height / image.height) * image.width),
          );
          const height = Math.round(
            Math.min(rect.height, (rect.width / image.width) * image.height),
          );

          return (
            <div style={{ position: "relative", width, height }}>
              <Image
                src={image.src}
                layout="fill"
                objectFit="contain"
                alt={"alt" in image ? image.alt : ""}
                sizes={
                  typeof window !== "undefined"
                    ? `${Math.ceil((width / window.innerWidth) * 100)}vw`
                    : `${width}px`
                }
                loader={NextImgCustomLoader}
              />
            </div>
          );
        },
      }}
    />
  );
}
